// extracted by mini-css-extract-plugin
export const container = "contact-module--container--HevGw";
export const layout = "contact-module--layout--PVoJT";